import { Action, Selector, State, StateContext } from '@ngxs/store';
import { IColumnDefinitionView } from '../../models/IColumnDefinitionView';
import {
  AddColumnDefinition,
  RemoveColumnDefinition,
} from '../actions/columnDefenition.action';

export class ColumnDefinitionStateModel {
  colDef: IColumnDefinitionView[];
}

@State({
  name: 'colDef',
  defaults: {
    colDef: [],
  },
})
export class ColumnDefinitionState {
  @Selector()
  getColumnDefinition(state: ColumnDefinitionStateModel) {
    return state.colDef;
  }

  @Action(AddColumnDefinition)
  add(
    { patchState }: StateContext<ColumnDefinitionStateModel>,
    { payload }: AddColumnDefinition
  ) {
    patchState({ colDef: payload });
  }

  @Action(RemoveColumnDefinition)
  remove({ patchState }: StateContext<ColumnDefinitionStateModel>): void {
    patchState({ colDef: [] });
  }
}
